<script>
export default {
    name: "ConstructionBuildingTab",
    props: {
        construction: {required: true},
        shows: {required: false, default: []},
    }
}
</script>

<template>
    <div class="row">
        <div class="col-xg-2 col-lg-3 col-md-4 col-xs-12">
            <img v-if="construction.building.highlight" v-bind:src="construction.building.highlight"
                 width="100%" class="border-img" style="cursor: pointer" @click="showGallery(info.building, 0)"/>
            <div v-if="!construction.building.photos.length" style="width: 100%;min-height: 140px; display: block;">
                <div style="text-align: center;">
                    <i class="fa fa-photo border-img"
                       style="font-size: 50px; line-height: 140px; height: 140px; opacity: .5; width: 100%; text-align: center;"></i>
                </div>
            </div>
        </div>
        <div class="col-xg-10 col-lg-9 col-md-8 col-xs-12">
            <div class="portlet light" style="padding-bottom:0">
                <h4><b>{{ construction.building.name }}</b></h4>
            </div>
            <div class="portlet light-grey">
                <p>
                    <strong style="width: 110px;display: inline-block;">Incorporadora: </strong>
                    <span v-if="construction.building.incorporator">{{ construction.building.incorporator.name }}</span>
                    <span v-else>-</span>
                </p>
                <p>
                    <strong style="width: 110px;display: inline-block;">Administradora: </strong>
                    <span v-if="construction.building.manager">{{ construction.building.manager.name }}</span>
                    <span v-else>-</span>
                </p>
                <p>
                    <strong style="width: 110px;display: inline-block;">Construtora: </strong>
                    <span v-if="construction.building.developer">{{ construction.building.developer.name }}</span>
                    <span v-else>-</span>
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionBuildingTab.vue?15043ec7